import { FC, PropsWithChildren } from "react";
import Footer from "components/layout/footer";
import Header from "components/layout/header";
import Sidebar from "components/layout/sidebar";
import { RootState } from "store/types";
import { connect } from "react-redux";

interface StateProps {
  isAuthenticated: boolean;
};

interface OwnProps {
  tabNav?: boolean
};

interface FullLayoutProps extends OwnProps, StateProps, PropsWithChildren<{}> {};

const FullLayout: FC<FullLayoutProps> = ({ isAuthenticated, children, tabNav }: FullLayoutProps) => {
  return (
    <div className={`app app-layout-full ${isAuthenticated ? 'app-layout-authorized' : ''}`.trim()}>
      {isAuthenticated && (
        <Sidebar />
      )}
      <Header />
      {tabNav && (
        <div className="app-tab-nav" id="app-tab-nav" />
      )}
      <div className="app-content container-fluid">
        {children}
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  isAuthenticated: state.session.isAuthenticated,
});

export default connect<StateProps, {}, OwnProps, RootState>(
  mapStateToProps
)(FullLayout);
